import React from 'react'
import './generalCSS/pagenotfound.css'

const PageNotFound = () => {
	return (
		<>
			<div className="page-not-found">
				<h1>404</h1>
				<p>Oops! Page not found.</p>
			</div>
		</>
	)
}

export default PageNotFound;